// core
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

// services
import { QuoteService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class QuoteResolver implements Resolve<any> {

  constructor(private quoteService: QuoteService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
    return this.quoteService.getBySlug(route.params.uuid);
  }
}
